var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.LogHistory-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "LogHistory-st0",
    d: "M3.9,3.9H1.6l3.3-3.2v2.2l0,0c0,0.3-0.1,0.5-0.3,0.7C4.4,3.8,4.1,3.9,3.9,3.9L3.9,3.9z M15.2,1v14 c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.3H1.8c-0.3,0-0.5-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.7V5h3.1 c0.6,0,1.1-0.2,1.5-0.6C5.7,4,6,3.5,6,2.9V0h8.3c0.3,0,0.5,0.1,0.7,0.3C15.1,0.5,15.2,0.7,15.2,1L15.2,1z M12.2,11.7 c0-0.3-0.2-0.6-0.6-0.6H4.3c-0.3,0-0.6,0.2-0.6,0.6c0,0.3,0.2,0.6,0.6,0.6h7.3C12,12.3,12.2,12,12.2,11.7z M12.2,8 c0-0.3-0.2-0.6-0.6-0.6H4.3C4,7.4,3.8,7.7,3.8,8c0,0.3,0.2,0.6,0.6,0.6h7.3C12,8.6,12.2,8.3,12.2,8z M12.2,4.3 c0-0.3-0.2-0.6-0.6-0.6H9.4C9.1,3.7,8.8,4,8.8,4.3c0,0.3,0.2,0.6,0.6,0.6h2.3l0,0C12,4.8,12.2,4.6,12.2,4.3L12.2,4.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogHistory);
export default __webpack_public_path__ + "static/media/LogHistory.ef452aa777017db0567e4806133e5fb5.svg";
export { ForwardRef as ReactComponent };